import $ from "jquery";
import { renderBootstrapErrors } from "./util/render_bootstrap_errors";
import toastr from "toastr";

const formSuccess = function (/*e, data, status, xhr*/) {
  $("#contactModal").modal("hide");
  toastr.info("Message successfully sent");
};

const formError = function (e, xhr) {
  renderBootstrapErrors($(this), xhr.responseJSON);
};

$(document).on("turbolinks:load", function () {
  $("#new_contact_message")
    .on("ajax:success", formSuccess)
    .on("ajax:error", formError);
});
